import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

function NavBarMolor() {
    return (
        <Navbar expand="lg" className="bg-body-tertiary">
            <Container>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="/">Home</Nav.Link>
                        <Nav.Link href="/getdata">Access to data</Nav.Link>
                        <Nav.Link href="/credits">Credits</Nav.Link>
                        <Nav.Link href="/publications"> Relevant publications</Nav.Link>
                        <Nav.Link href="https://ionov.me/molor-web/" target={"_blank"}> Molor query interface</Nav.Link>

                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavBarMolor;